<template>
  <div>
    <g-master name="trabajos"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              ref="master"
              :beforeSend="master.beforeSend"
              @params="paramsTable"
    >
      <template slot="customButton">
        <g-btn-excel :endpoint="`${master.endpoint}_/downloadExcel`" :params="paramsExcel" fileName="HABILIDADES Y CONOCIMIENTOS"/>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Etiqueta')">
              <a-input style="width: 100%"
                       v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Valor')">
              <a-input style="width: 100%"
                       v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          beforeSend: (data) => {
            data.id_skill = this.id_skill
            return data
          },
          endpoint: 'skill_param_item',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'value'},
            {name: 'label'}
          ]
        }
      }
    },
    props: ['id_skill'],
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_skill: this.id_skill
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/SkillParamItem.vue